import { useCasNavigationMenuData } from 'src/compass/site/layout';

export function useNavigationMenuData() {
  const navData = useCasNavigationMenuData();
  return navData;
}
